/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  UserGetLoyaltyTransactionHistoryParams,
  UserListReferralsParams,
} from '../api'
import { EUserReferralQueryKey } from './user-referral.types'
import userReferralService from './user-referral.service'
import { Cookie } from '@repo/tools'

export const getReferralCodesOptions = () => {
  return {
    queryKey: [EUserReferralQueryKey.GET_REFERRAL_CODES],
    queryFn: () => userReferralService.getReferralCodes(),
    enabled: !!Cookie.get('access_token'),
  }
}

export const getReferralListOptions = (params: UserListReferralsParams) => {
  return {
    queryKey: [EUserReferralQueryKey.GET_REFERRAL_LIST, params],
    queryFn: ({ pageParam = 0 }) =>
      userReferralService.getReferralList({
        ...params,
        skip: pageParam * (params.limit || 10),
      }),
    staleTime: 1,
    getNextPageParam: (lastPage: any, allPages: any) => {
      const total = lastPage.data?.total
      const referrals = lastPage.data?.referrals || []
      const limit = params.limit || 10

      // If we have total count, use it for pagination
      if (total !== undefined && total !== null) {
        const currentLength = allPages.reduce(
          (acc: number, page: any) => acc + (page.data?.referrals?.length || 0),
          0,
        )
        return currentLength < total ? allPages.length : undefined
      }

      // Fallback: If no total, check if we got fewer referrals than requested
      // This indicates we've reached the end
      if (referrals.length < limit) {
        return undefined
      }

      // If we got exactly the limit, there might be more data
      return allPages.length
    },
    initialPageParam: 0,
  }
}
export const getLoyaltyTransactionHistoryOptions = (
  params: UserGetLoyaltyTransactionHistoryParams,
) => {
  return {
    queryKey: [EUserReferralQueryKey.GET_LOYALTY_TRANSACTION_HISTORY, params],
    queryFn: ({ pageParam = 0 }) =>
      userReferralService.getLoyaltyTransactionHistory({
        ...params,
        skip: pageParam * (params.limit || 10),
      }),
    staleTime: 1,
    getNextPageParam: (lastPage: any, allPages: any) => {
      const total = lastPage.data?.total
      const transactions = lastPage.data?.transactions || []
      const limit = params.limit || 10

      // If we have total count, use it for pagination
      if (total !== undefined && total !== null) {
        const currentLength = allPages.reduce(
          (acc: number, page: any) =>
            acc + (page.data?.transactions?.length || 0),
          0,
        )
        return currentLength < total ? allPages.length : undefined
      }

      // Fallback: If no total, check if we got fewer transactions than requested
      // This indicates we've reached the end
      if (transactions.length < limit) {
        return undefined
      }

      // If we got exactly the limit, there might be more data
      return allPages.length
    },
    initialPageParam: 0,
    enabled: !!params.userID && params.userID !== 0,
  }
}
export const getLoyaltyMissionsOptions = () => {
  return {
    queryKey: [EUserReferralQueryKey.GET_LOYALTY_MISSIONS],
    queryFn: () => userReferralService.getLoyaltyMissions(),
  }
}
export const getLoyaltyPortfolioOptions = () => {
  return {
    queryKey: [EUserReferralQueryKey.GET_LOYALTY_PORTFOLIO],
    queryFn: () => userReferralService.getLoyaltyPortfolio(),
  }
}
